import axios from "axios";
import io from "socket.io-client";
import { useEffect } from "react";

const Test = () => {
  useEffect(() => {
    const socket = io("https://ligavirtualf1.es:30001");
    // Emitir un mensaje al servidor
    //socket.emit("broadcast_message", "Message sent from udp2ws");

    // Escuchar eventos del servidor
    socket.on("car_info", (data: any) => {
      console.log(data);
    });
    socket.on("car_update", (data: any) => {
      console.log(data);
    });
    socket.on("client_loaded", (data: any) => {
      console.log(data);
    });
    socket.on("collision_with_car", (data: any) => {
      console.log(data);
    });
    socket.on("lap_completed", (data: any) => {
      console.log(data);
    });
    socket.on("new_session", (data: any) => {
      console.log(data);
    });
    socket.on("session_info", (data: any) => {
      console.log(data);
    });
    socket.on("server_error", (data: any) => {
      console.log(data);
    });
    socket.on("console", (messageObject: any) => {
      console.log(messageObject);
    });

    socket.emit("car_info", 0);

    socket.emit("car_info", 1);
  }, []);

  return <label>a</label>;
};

export default Test;
